import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../common/Table';
import SearchForm from './SearchForm';

export default class Tickets extends Component {
    constructor(props) {
        super(props)
        this.state = {
            Tickets: [],
            searchConditions: {},
            lastPage: 1,
            currentPage: 1,
            from: '',
            to: '',
            total: '',
        }
        this.handleEdit = this.handleEdit.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
    }

    /**
     * Prepare render jobs
     */
    prepareRender(response) {
        response.map((Ticket) => {
            var ary = [];
            if (Ticket.included == '1') {
                ary.push("報酬に含まれます。");
            }
            if (Ticket.actual_expense_settlement == '1') {
                ary.push("現地で実費精算可能です。");
            }
            if (Ticket.consultation_possible == '1') {
                ary.push("メッセージで相談可能です。");
            }

            Ticket.transportation_expenses = ary.join('\n')
        })
    }
    
    /**
     * Init data and form job or list jobs
     */
    componentWillMount() {
        const keySearch_str = this.props.location.search.substring(1);
        let keySearch_arr = {page: 1};
        if (keySearch_str) {
            keySearch_arr = JSON.parse('{"' + decodeURI(keySearch_str.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}');
        }

        //always get list data
        axios.post('/api/tickets/search', keySearch_arr).then(response => {
            this.prepareRender(response.data.data);
            this.setState({
                Tickets: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                searchConditions: keySearch_arr,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: keySearch_str
            });
        });
    }
    
    /**
     * Sort data
     */
    handleSort(key) {
        //add sort params to search conditions
        let newSearchConditions = this.state.searchConditions;
        newSearchConditions.sort_column = key.sort_column;
        newSearchConditions.sort_type = key.sort_type;
        this.setState({
            searchConditions: newSearchConditions
        });
        axios.post('/api/tickets/search', newSearchConditions).then(response => {
            this.prepareRender(response.data.data);
            this.setState({
                Tickets: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(newSearchConditions)
            });
        });
    }
    
    /**
     * Get search data
     */
    handleSearch(key) {
        this.setState({
            searchConditions: key
        });
        axios.post('/api/tickets/search', key).then(response => {
            this.prepareRender(response.data.data);
            this.setState({
                Tickets: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(key)
            });
        });
    }
    
    /**
     * Edit job
     * job: Object Client
     */
    handleEdit(job) {
        this.props.history.push('/tickets/edit/' + job.id);
    }

    /**
     * Download job
     */
    handleDownload() {
        location.href = "/tickets/download?"+ $.param(this.state.searchConditions);    
    }
    
    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }

    renderSupportAreas() {
        let supportAreas = this.state.helper.helper_support_areas;
        // console.log(supportAreas);
        if (supportAreas) {
            return (
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right"> 助っ人できそうなエリア</label>
                    <div className="col-sm-8">
                        {supportAreas.map((area, index) => {
                            return (
                                <p className="col-value text-left">{area.pref.name}{area.city.name}</p>
                            );
                        })}
                    </div>
                </div>
            );
        }
    }

    render() {
        const option = {
            1:{text:'公開中',classHTML:'text-primary'},
            0:{text:'非公開',classHTML:'text-gray'},
        };
        const colorRows = {
            0:'table-dark',
            1:'table-primary',
            2:'table-danger',
            3:'table-info',
            4:'table-warning',
            5:'table-success',
            6:'table-dark',
            7:'table-light',
            8:'table-light',
            9:'table-dark',
            null:'table-light'
        };
        const optionTR = {
            colors : colorRows,
            conditionColumn: 'valid_flg'
        }
        const columns = [
            {name: 'id', title: 'No.', isSort: 1, type: 'text'},
            {name: 'staff_id', title: 'ワーカーID', isSort: 1, type: 'text'},
            {name: 'first_last_name', title: 'ワーカー名', isSort: 1, type: 'text', isSearch:true},
            {name: 'nickname', title: 'ニックネーム', isSort: 1, type: 'text', isSearch:true},
            {name: 'categories_name', title: 'チケットカテゴリ', isSort: 1, type: 'text_break_line', isSearch:true},
            {name: "pref", title: "居住地(都道府県)", isSort: 1, type: "text"},
            {name: "city", title: "居住地(市区町村)", isSort: 1, type: "text"},
            {name: 'valid_flg', title: '公開状態', isSort: 1, type: 'status_option', option:option},
            {name: 'price', title: '時給', isSort: 1, type: 'convert_to_number_with_zero', prefix:'¥'},
            {name: 'transportation_expenses', title: '交通費', isSort: 0, type: 'text_break_line'},
        ]
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item active" aria-current="page">チケット一覧</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <main id="main">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h4 className="mt-2 mb-0 page-title">チケット一覧</h4>
                                        </div>
                                        <div className="col text-right">
                                            <button className="btn btn-light" type="button" data-toggle="collapse" data-target="#search_order" aria-expanded="false" aria-controls="search_order">絞込検索</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <SearchForm onSearch={this.handleSearch} />
                                        </div>
                                    </div>
                                </div>
                                <Table optionTR={optionTR} optionDownload={1} onDownload={this.handleDownload} onSearch={this.handleSearch} onSort={this.handleSort} onEdit={this.handleEdit} header={columns} data={this.state.Tickets} 
                                    myPagination={1} searchConditions={this.state.searchConditions} lastPage={this.state.lastPage} currentPage={this.state.currentPage} from={this.state.from} to={this.state.to} total={this.state.total} />
                            </div>
                        </div>
                    </div>
                </main>
            </React.Fragment>
        );
    }

}